































import { Mixins, Component, Prop, Watch } from 'vue-property-decorator';
import { AxPage } from '@/mixins';

import * as I from '@/interfaces';

@Component
export default class AxRelayPortDialog extends Mixins(AxPage) {
  on = true;

  @Prop({ default: () => new I.DataParam() })
  param!: I.DataParam;

  @Prop({ type: String, default: '그룹 선택' })
  title!: string;

  @Prop({ type: String, default: '895' })
  width!: string;

  @Prop({ type: String, default: '600' })
  height!: string;

  @Watch('on')
  onSwitchChanged() {
    this.$emit('changed', this.on);
  }

  onDialogChanged() {
    this.param.callback();
  }

  async onDialogRowClicked(item: I.SensorExtData) {
    console.log(item);

    const confirm = await this.showConfirmModal(
      '확인',
      `AxACU : ${item.acuID}, 센서 포트: ${item.extID}-${item.portID}<br /><br />선택한 항목이 맞습니까?`
    );
    if (confirm !== 0) return;
    this.param.selected = [item];
    this.param.callback();
    this.on = false;
  }

  onSaveClicked() {
    this.param.callback();
    this.on = false;
  }

  onCancelClicked() {
    this.on = false;
  }
}
